import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isValidElement } from 'react';
import { Dropdown } from '../dropdown';
import { logError } from '../helpers';
import { useToggleButton } from './context';
import { MESSAGES } from './debug-messages';
export default function DropdownToggle({ children }) {
    var _a;
    const { activeItem, firstButtonId } = useToggleButton();
    // Assign the trigger as either the activeItem or the first child
    const trigger = (_a = children.find((el) => isValidElement(el) && el.props.id === activeItem)) !== null && _a !== void 0 ? _a : children[0];
    if (!isValidElement(trigger)) {
        logError(MESSAGES.INVALID_ACTIVE_ITEM);
        return null;
    }
    return (_jsx(Dropdown, Object.assign({ trigger: trigger }, { children: _jsx(Dropdown.Category, Object.assign({ noDivider: true }, { children: children.filter((el) => isValidElement(el) &&
                el.props.id !== activeItem &&
                el.props.id !== firstButtonId) })) })));
}
